import ReactFileViewer from 'react-file-viewer';
import React, { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Button, Stack, Typography } from '@mui/material';
import './styles.css'
import PdfPreviewer from './viewers/pdfViewer';
import JsonPreviewer from './viewers/jsonViewer';
import TxtViewer from './viewers/textViewer';
import apiClient from '../../services/apiClient';
import { Download, FileDownload } from '@mui/icons-material';
const ErrorMessage = ({ error }) => {
  if (!error) {
    return null;
  }
  return (
    <div
      style={{
        color: 'red',
        fontSize: '14px',
      }}
    > -----------------------------{error} </div>
  );
};

const DocViewerPage = () => {
  const { id } = useParams(); // Extract ID from URL params
  const [fileType, setFileType] = useState('');
  const [filePath, setFilePath] = useState('');
  const [fileInfo, setFileInfo] = useState(null);
  const [fetchingFile, setFetchingFile] = useState(false);
  const [error, setError] = useState('');
  const location = useLocation(); // To access query params

  const downloadFile = async () => {
    try {
      setFetchingFile(true);
      // save file 
      const url = filePath;
      const link = document.createElement('a');
      link.href = url;
      link.download = fileInfo.docs;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      setFetchingFile(false);
    } catch (e) {
      console.log('Error fetching file:', e);
      setFetchingFile(false);
    }
  }

  // Function to extract query params
  const getQueryParams = () => {
    const searchParams = new URLSearchParams(location.search);
    return {
      case_name: searchParams.get('case_name') || 'all',
      subject_name: searchParams.get('subject_name') || 'all',
      device_name: searchParams.get('device_name') || 'all',
    };
  };



  // Function to fetch document details using the ID
  const fetchDocInfo = async (id) => {
    try {

      const res = await apiClient.post(`/chatbot/get_docsinfo_byid`, { "docs_id": id });
        const data = res.data;
        setFileInfo(data.data[0])
        // Extract source path and extension from the response
        const source = data.data[0]?.source_path;
        const extension = data.data[0]?.extension;
        return { source, extension };
      
    } catch (e) {
      console.log('Error fetching document info:', e);
      setError('Error fetching document info');
      return null;
    }
  };


  const handleFileView = async (source, extension) => {
    try {
      setFetchingFile(true);
      
      // Use axios to make a POST request, specifying responseType as 'blob' to handle the binary data
      const res = await apiClient.post('/chatbot/get_docs_final_from_path', { path: source }, { responseType: 'blob' });
  
      // Create a URL for the fetched blob
      const blob = res.data;
      const fileUrl = URL.createObjectURL(blob);
  
      // Set file type and URL for ReactFileViewer
      setFileType(extension);
      setFilePath(fileUrl);
  
      // Revoke URL after a timeout to free resources
      setTimeout(() => {
        URL.revokeObjectURL(fileUrl);
      }, 100000);
  
      setFetchingFile(false);
    } catch (e) {
      console.error('Error fetching file:', e);
      setError('Error fetching file');
      setFetchingFile(false);
    }
  };
  

  // useEffect to fetch document details and file when 'id' changes
  useEffect(() => {
    // if (true) {
    fetchDocInfo(id).then((docInfo) => {
      if (docInfo && docInfo.source) {
        handleFileView(docInfo.source, docInfo.extension);
      }
    });
    // }
  }, [id]); // Dependency array listens to changes in 'id'


  const reactFileViewerAllowed = ['docx', 'xlsx', 'csv', 'jpg', 'jpeg', 'png'];
  const singleViewers = {
    pdf: PdfPreviewer,
    json: JsonPreviewer,
    txt: TxtViewer,
  }

  return (
    <div>
      {fetchingFile && <p>Loading...</p>}
      {filePath && reactFileViewerAllowed.includes(fileType) && (
        <>
          <Button endIcon={<Download />} ml='auto' size='small' variant='contained' onClick={downloadFile}>Download</Button>

          <div style={{ height: '95vh' }}>

            <ReactFileViewer
              fileType={fileType}
              filePath={filePath}
              onError={(e) => {
                console.log('Error in file viewer:', e);
                setError('Error displaying file');
              }}
              style={{ height: '100%', overflow: 'auto' }}


              errorComponent={ErrorMessage}

            />
          </div>
        </>
      )}

      {filePath && Object.keys(singleViewers).includes(fileType) && (<>
        <Button endIcon={<Download />} ml='auto' size='small' variant='contained' onClick={downloadFile}>Download</Button>

        <div style={{ height: '95vh' }}>

          {React.createElement(singleViewers[fileType], { url: filePath })}

        </div>
      </>)}
      {
        filePath && !reactFileViewerAllowed.includes(fileType) && !Object.keys(singleViewers).includes(fileType) && (
          <Stack alignItems={"center"} justifyContent={"center"} sx={{ height: '100%' }} spacing={2}>
            <FileDownload fontSize={"10rem"} size={"10rem"}>{fileType}</FileDownload>
            <Typography variant='h2'>
              {
                fileInfo?.docs
              }
            </Typography>

            <Typography variant='h2'>
              extension: {
                fileInfo?.extension
              } is not supported
            </Typography>

            <Button endIcon={<Download />} size='large' variant='contained' onClick={downloadFile}>Download</Button>
          </Stack>

        )
      }
      {error && <p>{error}</p>}
    </div>
  );
};

export default DocViewerPage;